import { render } from "./TemplateSelectModal.vue?vue&type=template&id=62f59710&scoped=true&ts=true"
import script from "./TemplateSelectModal.vue?vue&type=script&lang=ts"
export * from "./TemplateSelectModal.vue?vue&type=script&lang=ts"

import "./TemplateSelectModal.vue?vue&type=style&index=0&id=62f59710&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f59710"]])

export default __exports__